// extracted by mini-css-extract-plugin
export default {"tooltip":"RO-z","arrow":"SO-z"};